import dayjs from 'dayjs'

import api from '../../../api'
import {
	AssignCoachesResetAction,
	AssignCoachSelectAction,
	AssignCoachSetLoadingStateAction,
	AssignCoachSetSearchValueAction,
	Coach,
	CoachHistoryLogRequest,
	HistoryLogCoachData,
	SEARCH_COACHES_ACTION_TYPES,
} from '../../../types/coaches'
import { AppThunkAction } from '../../index'
import { executeResponseError } from '../../../helpers'

export const setSelectedCoach = (coach: string[]): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SEARCH_COACHES_ACTION_TYPES.SELECTED_ASSIGN_COACH,
			payload: coach,
		})
	}
}

export const setAllCoaches = (coaches: Coach[]): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: SEARCH_COACHES_ACTION_TYPES.GET_ALL_COACHES,
			payload: coaches,
		})
	}
}

export const getCoachesToASsign = (data: any): AppThunkAction<Promise<any>> => {
	return async dispatch => {
		try {
			const res = await api.coach.getCoachesToAssign(data)
			dispatch(setSelectedCoach([]))
			dispatch(setAllCoaches(res.data.result))
			return res.data.result
		} catch (e: any) {
			const error = executeResponseError(e, 'Get coaches error')
			throw new Error(error || '')
		}
	}
}

export const setCoachData = (data: Coach | {}): AppThunkAction<void> => {
	return dispatch => {
		dispatch({
			type: SEARCH_COACHES_ACTION_TYPES.GET_COACH,
			payload: data,
		})
	}
}

export const getCoachData = (id: string): AppThunkAction<Promise<void>> => {
	return async dispatch => {
		try {
			const timezoneOffsetInMinutes = -dayjs().utcOffset()

			const res = await api.coach.getCoachData(
				timezoneOffsetInMinutes,
				id
			)
			if (res.data?.result) {
				dispatch(setCoachData(res.data?.result))
			}
		} catch (e: any) {
			// todo: need add 500 error code
			const error = executeResponseError(e, 'Get coach error')
			if (error) {
				throw new Error(error)
			}
		}
	}
}
export const blockCoach = (id: string): AppThunkAction<Promise<void>> => {
	return async dispatch => {
		try {
			const res = await api.coach.blockCoach(id)
			if (res.data?.result) {
				dispatch(getCoachData(id))
			}
		} catch (e: any) {
			// todo: need add 500 error code
			const error = executeResponseError(e, 'Block coach error')
			if (error) {
				throw new Error(error)
			}
		}
	}
}
export const unblockCoach = (id: string): AppThunkAction<Promise<void>> => {
	return async dispatch => {
		try {
			const res = await api.coach.unblockCoach(id)
			if (res.data?.result) {
				dispatch(getCoachData(id))
			}
		} catch (e: any) {
			// todo: need add 500 error code
			const error = executeResponseError(e, 'Block coach error')
			if (error) {
				throw new Error(error)
			}
		}
	}
}

export const setCoachHistoryLog = (
	data: HistoryLogCoachData[]
): AppThunkAction<void> => {
	return dispatch => {
		dispatch({
			type: SEARCH_COACHES_ACTION_TYPES.GET_COACH_HISTORY_LOG,
			payload: data,
		})
	}
}

export const setCoachHistoryLogSearch = (
	data: string
): AppThunkAction<void> => {
	return dispatch => {
		dispatch({
			type: SEARCH_COACHES_ACTION_TYPES.GET_COACH_HISTORY_LOG_SERCH,
			payload: data,
		})
	}
}

export const getHistoryLogCoach = (
	historyReqestData: CoachHistoryLogRequest
): AppThunkAction<Promise<void>> => {
	return async dispatch => {
		try {
			const res = await api.coach.getHistoryLogCoach(historyReqestData)
			if (res.data?.result?.records) {
				dispatch(setCoachHistoryLog(res.data.result.records))
			}
		} catch (e: any) {
			// todo: need add 500 error code
			const error = executeResponseError(e, 'Block coach error')
			if (error) {
				throw new Error(error)
			}
		}
	}
}

export const setAssignCoachSearchValue = (
	searchValue: string
): AssignCoachSetSearchValueAction => ({
	type: SEARCH_COACHES_ACTION_TYPES.SET_ASSIGN_COACH_SEARCH_VALUE,
	payload: searchValue,
})

export const selectCoachForAssigning = (
	coachId: string
): AssignCoachSelectAction => ({
	type: SEARCH_COACHES_ACTION_TYPES.ASSIGN_COACH_SELECT,
	payload: coachId,
})

export const setLoadingStatusForAssignCoaches = (
	loading: boolean
): AssignCoachSetLoadingStateAction => ({
	type: SEARCH_COACHES_ACTION_TYPES.ASSIGN_COACH_LOADING,
	payload: loading,
})

export const assignCoachesReset = (): AssignCoachesResetAction => ({
	type: SEARCH_COACHES_ACTION_TYPES.ASSIGN_COACH_RESET,
})
